/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
    Flex,
    Heading,
    Input,
    Button,
    InputGroup,
    Stack,
    InputLeftElement,
    chakra,
    Box,
    Avatar,
    FormControl,
    FormHelperText,
    InputRightElement,
    Text,
    Spinner,
    Center
} from "@chakra-ui/react";
import { useCreateUserWithEmailAndPassword } from 'react-firebase-hooks/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, firestore } from "../../../utils/firebase";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from 'uuid';

import { FaUserAlt, FaLock } from "react-icons/fa";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
    useParams
} from "react-router-dom";
import { actions } from "react-table";
import { DataContext } from "../../../state/DataContext/DataContext";

const CFaUserAlt = chakra(FaUserAlt);
const CFaLock = chakra(FaLock);

const UserSignup = () => {
    const { tenantID } = useParams();
    const [showPassword, setShowPassword] = React.useState(false);
    const [userData, setUserData] = React.useState(false);
    const { data, actions } = React.useContext(DataContext);


    const [
        createUserWithEmailAndPassword,
        user,
        loading,
        error,
    ] = useCreateUserWithEmailAndPassword(auth);

    React.useEffect(() => {
        actions.getTenantBusinessName(tenantID)

    }, [])

    React.useEffect(() => {
        if (user) {
            actions.addUserToTenant(tenantID, user?.user?.uid, userData.Name, userData.Emai)
        }
    }, [user])

    const handleShowClick = () => setShowPassword(!showPassword);

    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const onSubmit = formData => {
        setUserData({
            Email: formData.email,
            TenantID: data.tenantID,
            BusinessName: data.Tenant.BusinessName,
            Name: formData.Name,
            Role: "User"
        })
        createUserWithEmailAndPassword(formData.email, formData.password)

    }

    return (
        <Flex
            flexDirection="column"
            width="100wh"
            height="100vh"
            backgroundColor="gray.50"

            justifyContent="center"
            alignItems="center"
        >
            <Route exact path="/signup">
                {(user && !loading) && <Redirect to={`${userData.TenantID}/admin`} />}
            </Route>
            <Stack
                flexDir="column"
                mb="2"
                justifyContent="center"
                alignItems="center"
            >
                <Heading fontSize={'4xl'}><Text display="inline" fontWeight="black" color="green.500">Job</Text><Text display="inline" fontWeight="bold">WorkPad</Text></Heading>
                <Text textAlign={"center"} fontSize={'lg'} color={'gray.600'} fontWeight="semibold">
                    Manage, schedule and create checklists <br />with JobWorkPad. <br />
                </Text>
                <Heading color="green.400" textAlign="center">
                    <Text color="black">You're invited to</Text>
                    {data.Tenant?.BusinessName}</Heading>
                <Box minW={{ base: "90%", md: "420px" }}>
                    <form onSubmit={handleSubmit(onSubmit)}>

                        <Stack
                            spacing={4}
                            p="1rem"
                            backgroundColor="white"
                            boxShadow="md"
                            borderRadius="0.5em"
                        >
                            {loading ? <Center height="200px"><Spinner /></Center> :
                                <>
                                    {error?.message}
                                    <FormControl>
                                        <InputGroup>
                                            <Input placeholder="Name" {...register("Name", { required: true })} />
                                        </InputGroup>
                                    </FormControl>
                                    <FormControl>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents="none"
                                                children={<CFaUserAlt color="gray.300" />}
                                            />
                                            <Input type="email" placeholder="email" {...register("email", { required: true })} />
                                        </InputGroup>
                                    </FormControl>
                                    <FormControl>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents="none"
                                                color="gray.300"
                                                children={<CFaLock color="gray.300" />}
                                            />
                                            <Input type={showPassword ? "text" : "password"} placeholder="Password" {...register("password", { required: true })} />
                                            <InputRightElement width="4.5rem">
                                                <Button h="1.75rem" size="sm" onClick={handleShowClick}>
                                                    {showPassword ? "Hide" : "Show"}
                                                </Button>
                                            </InputRightElement>
                                        </InputGroup>
                                        <FormHelperText textAlign="right">
                                            {/* <Link>forgot password?</Link> */}
                                        </FormHelperText>
                                    </FormControl>
                                </>
                            }

                            <Button
                                type="submit"
                                borderRadius={0}
                                variant="solid"
                                colorScheme="green"
                                width="full"
                            >
                                Sign Up
                            </Button>
                        </Stack>
                    </form>
                </Box>
            </Stack>
            <Box>
                <Flex>
                    <Text marginRight="5px">
                        Already have an account?{" "}
                    </Text>
                    <Link to="/login">
                        <Text color="green.500" >Login </Text>
                    </Link>
                </Flex>

            </Box>
        </Flex>
    );
};

export default UserSignup;
